var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCroupierDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-online-doctor:not(.animated) .animable {opacity: 0;}svg#freepik_stories-online-doctor.animated #freepik--cross-icon--inject-39 {animation: 1.5s Infinite  linear heartbeat;animation-delay: 0s;}svg#freepik_stories-online-doctor.animated #freepik--pulse-icon--inject-39 {animation: 1.5s Infinite  linear heartbeat;animation-delay: 0s;}svg#freepik_stories-online-doctor.animated #freepik--Character--inject-39 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-online-doctor.animated #freepik--Chat--inject-39 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}            @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "214.64px 209.774px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m253.75 180.64c-28.19-40.82-68.42-129-133.07-72.88-64.17 55.77-16.05 154.59 24.79 188 41.28 33.69 174.23 64.24 192.75-20.91 12.78-58.57-53.32-49.12-84.47-94.21z",
    fill: "#16A085",
    style: {
      transformOrigin: "214.64px 209.774px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m253.75 180.64c-28.19-40.82-68.42-129-133.07-72.88-64.17 55.77-16.05 154.59 24.79 188 41.28 33.69 174.23 64.24 192.75-20.91 12.78-58.57-53.32-49.12-84.47-94.21z",
    fill: "#fff",
    opacity: 0.9,
    style: {
      transformOrigin: "214.64px 209.774px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "animable",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    fill: "#f5f5f5",
    style: {
      transformOrigin: "250px 416.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "340.7px 314.54px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 340.71,
    cy: 314.54,
    r: 31.68,
    fill: "#fff",
    style: {
      transformOrigin: "340.71px 314.54px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m340.71 346.61a32.07 32.07 0 1 1 32.06-32.07 32.1 32.1 0 0 1-32.06 32.07zm0-63.35a31.29 31.29 0 1 0 31.29 31.28 31.31 31.31 0 0 0-31.29-31.28z",
    fill: "#16A085",
    style: {
      transformOrigin: "340.7px 314.54px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 335.61,
    y: 296.58,
    width: 10.2,
    height: 35.92,
    fill: "#16A085",
    style: {
      transformOrigin: "340.71px 314.54px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 335.61,
    y: 296.58,
    width: 10.2,
    height: 35.92,
    fill: "#16A085",
    style: {
      transformOrigin: "340.71px 314.54px",
      transform: "rotate(90deg)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "145.915px 95.275px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m126.11 75.07-0.68-0.73a30.75 30.75 0 0 1 16.81-8.1l0.14 1a29.74 29.74 0 0 0-16.27 7.83z",
    fill: "#16A085",
    style: {
      transformOrigin: "133.905px 70.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M118.71,86l-.93-.36a30.77,30.77,0,0,1,4-7.14l.8.6A30.24,30.24,0,0,0,118.71,86Z",
    fill: "#16A085",
    style: {
      transformOrigin: "120.18px 82.25px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 146.61,
    cy: 96.87,
    r: 27.44,
    fill: "#16A085",
    style: {
      transformOrigin: "146.61px 96.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M163,84.51a11.46,11.46,0,0,0-16.36-.15,11.45,11.45,0,0,0-16.35.15,11.71,11.71,0,0,0,.41,16.32l13,13a4.2,4.2,0,0,0,5.94,0l13-13A11.71,11.71,0,0,0,163,84.51Z",
    fill: "#fff",
    style: {
      transformOrigin: "146.657px 98.0304px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M146.61,108.86h0a1,1,0,0,1-.91-.67l-5.79-16.93-2.42,7.08a1,1,0,0,1-.95.67h-9.69a1,1,0,0,1,0-2h9l3.14-9.17a1,1,0,0,1,1.89,0l5.89,17.23,5.72-13.47a1,1,0,0,1,.86-.61,1,1,0,0,1,.93.51L157.3,97h9.11a1,1,0,0,1,0,2h-9.69a1,1,0,0,1-.88-.51l-2.37-4.24-5.94,14A1,1,0,0,1,146.61,108.86Z",
    fill: "#16A085",
    style: {
      transformOrigin: "146.63px 98.0135px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "234.719px 246.802px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M298.86,381.2H194.49A12.26,12.26,0,0,1,182.13,368L199,118a14.44,14.44,0,0,1,14.15-13.25H317.54A12.26,12.26,0,0,1,329.9,118L313,368A14.43,14.43,0,0,1,298.86,381.2Z",
    fill: "#263238",
    style: {
      transformOrigin: "256.017px 242.975px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m322 206.56h-2.63a3.42 3.42 0 0 1-3.45-3.7l3.23-47.79a4 4 0 0 1 3.95-3.7h2.63a3.42 3.42 0 0 1 3.45 3.7l-3.23 47.79a4 4 0 0 1-3.95 3.7z",
    fill: "#263238",
    style: {
      transformOrigin: "322.55px 178.965px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m197.48 174.68h-2.62a2.8 2.8 0 0 1-2.83-3l1.17-17.26a3.3 3.3 0 0 1 3.23-3h2.63a2.81 2.81 0 0 1 2.82 3l-1.17 17.26a3.29 3.29 0 0 1-3.23 3z",
    fill: "#16A085",
    style: {
      transformOrigin: "196.955px 163.05px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m195.4 205.5h-2.63a2.8 2.8 0 0 1-2.82-3l1.17-17.26a3.3 3.3 0 0 1 3.23-3h2.65a2.81 2.81 0 0 1 2.82 3l-1.17 17.26a3.29 3.29 0 0 1-3.25 3z",
    fill: "#16A085",
    style: {
      transformOrigin: "194.885px 193.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M296.65,381.2H192.28A12.26,12.26,0,0,1,179.92,368L196.8,118A14.44,14.44,0,0,1,211,104.79H315.33A12.26,12.26,0,0,1,327.69,118L310.8,368A14.43,14.43,0,0,1,296.65,381.2Z",
    fill: "#16A085",
    style: {
      transformOrigin: "253.805px 242.995px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "181.02 365.2 197.5 121.24 326.56 121.24 310.08 365.2",
    fill: "#fff",
    opacity: 0.3,
    style: {
      transformOrigin: "253.79px 243.22px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "231.97 365.2 278.03 121.24 306.94 121.24 260.88 365.2",
    fill: "#fff",
    opacity: 0.1,
    style: {
      transformOrigin: "269.455px 243.22px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "210.13 365.2 256.19 121.24 270.84 121.24 224.78 365.2",
    fill: "#fff",
    opacity: 0.1,
    style: {
      transformOrigin: "240.485px 243.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m250.14 110.92h25.17a1.5 1.5 0 0 1 1.52 1.63 1.78 1.78 0 0 1-1.74 1.64h-25.17a1.51 1.51 0 0 1-1.52-1.64 1.77 1.77 0 0 1 1.74-1.63z",
    fill: "#fff",
    style: {
      transformOrigin: "262.615px 112.555px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "244.9 405.25 236.08 406.09 232.9 385.74 241.72 384.89",
    fill: "#ffb573",
    style: {
      transformOrigin: "238.9px 395.49px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M235.07,401.78l9.24-2.87a.65.65,0,0,1,.82.38l3,7.33a1.52,1.52,0,0,1-1,2c-3.34,1-6.52,1.23-10.55,3-4.71,2-6.68,4.68-11.75,4.68-3.63,0-4.45-3.33-2.91-3.79,7-2.12,6.08-3.86,11.16-9.33A4.68,4.68,0,0,1,235.07,401.78Z",
    fill: "#263238",
    style: {
      transformOrigin: "234.705px 407.587px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "232.9 385.74 234.54 396.24 243.37 395.39 241.73 384.89",
    opacity: 0.2,
    style: {
      transformOrigin: "238.135px 390.565px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m239.28 128.6c-11.57-1.36-23.08-0.45-34.63 1.79a9.23 9.23 0 0 0-7.41 8c-1.25 11.06-2.68 35.85 2.9 72.83l47.28-4c0.09-6.71-4.68-37.28-0.74-69a8.47 8.47 0 0 0-7.4-9.62z",
    fill: "#fff",
    style: {
      transformOrigin: "221.76px 169.59px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M211.75,138.08l1.69,3.38a1,1,0,0,0,.89.58l1.83.1a1.42,1.42,0,0,0,.91-.28l3.15-2.35-3.89-2.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "215.985px 139.411px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m216.22 141.17a3.08 3.08 0 0 0-2.13-0.17c-1.49 5.25-3.12 20.32-3.29 27 4.52 13.17 6 14.5 6 14.5l2.29-15.85s-2.57-16.21-2.87-25.48z",
    fill: "#263238",
    style: {
      transformOrigin: "214.945px 161.692px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m229.27 105.8c-1.08 6.52-2 18.43 2.68 22.64-3.43 3.6-7.92 7.77-15.62 8.24s-6.51-4.86-4.56-7.71c7.19-1.92 6.84-7.28 5.43-12.29z",
    fill: "#ffb573",
    style: {
      transformOrigin: "221.132px 121.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M233.91,127.87a9.6,9.6,0,0,0-1.69-.55.67.67,0,0,0-.75.31c-.74,1.26-3,6.89-15.14,9.05,2,1.18,4.65,4.84,5.79,6.6,3.64-1.89,13.11-7.54,12.21-14.85A.74.74,0,0,0,233.91,127.87Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "225.36px 135.289px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m211.84 129.27a0.7 0.7 0 0 0-0.82-0.84 9.39 9.39 0 0 0-1.24 0.33 1 1 0 0 0-0.26 0.15c-0.93 0.86-6 8.18-1.25 14.1 1-1.61 4.45-5.26 8.06-6.33-3.42-1.54-5.1-4.41-4.49-7.41z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "211.299px 135.713px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m224.35 110.24-7.14 6.44a20.62 20.62 0 0 1 0.72 3.56c2.76-0.47 6.47-3.6 6.67-6.5a9.48 9.48 0 0 0-0.25-3.5z",
    opacity: 0.2,
    style: {
      transformOrigin: "220.936px 115.24px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m214.81 86.09c-6.16 2.41-6.56 7.47-6 13s6.58 1.87 7.92-1.59 6.61-14.75-1.92-11.41z",
    fill: "#263238",
    style: {
      transformOrigin: "214.098px 93.7045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M234.46,97.12c-1.71,8.71-2.28,13.88-7.26,17.89-7.51,6-17.68.82-18.58-8.16-.81-8.09,2.12-21,11.09-23.52A11.72,11.72,0,0,1,234.46,97.12Z",
    fill: "#ffb573",
    style: {
      transformOrigin: "221.616px 100.222px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m234.1 104.33c-7.33 0.39-5.78-3.77-4.45-6.16s-1.38-6.34 0.39-8.39c-3.16 1.26-6.49 0.22-10.72-2.72-3.28-2.29-7.39 6.86-11.39 2.27-3.78-4.33-0.27-10.86 8.81-11.91s10.73 5.37 16.69 4.8 3.89 4.34 2.72 5.34c5 0.33 7.73 5.11-2.05 16.77z",
    fill: "#263238",
    style: {
      transformOrigin: "223.549px 90.8296px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m235 88.17a7.34 7.34 0 0 0 3.81-6.39c1.98 3.47 1.77 7.41-3.81 6.39z",
    fill: "#263238",
    style: {
      transformOrigin: "237.474px 85.0569px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M216,106.42a6,6,0,0,0,4.58-1.08.2.2,0,0,0,0-.29.21.21,0,0,0-.29,0,5.77,5.77,0,0,1-5.09.79.23.23,0,0,0-.27.14.21.21,0,0,0,.14.26A5.29,5.29,0,0,0,216,106.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "217.782px 105.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m236.23 107a8.52 8.52 0 0 1-5.59 3.22c-2.91 0.38-3.88-2.33-2.66-4.86 1.11-2.28 4-5.22 6.68-4.43s3.25 3.87 1.57 6.07z",
    fill: "#ffb573",
    style: {
      transformOrigin: "232.321px 105.527px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m233.34 296.37c0.35-26.11 3.69-88.3 3.69-88.3l-36.86 3.11s7.33 64.09 11.75 90.73c4.6 27.69 18.71 92.56 18.71 92.56l15-1.28s-5.48-76.63-12.29-96.82z",
    fill: "#263238",
    style: {
      transformOrigin: "222.9px 301.27px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "229.73 394.88 247.52 393.37 246.82 387.63 228.28 388.87",
    fill: "#16A085",
    style: {
      transformOrigin: "237.9px 391.255px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M221.32,97.64c-.09.71-.55,1.25-1,1.2s-.76-.67-.66-1.39.55-1.25,1-1.2S221.42,96.93,221.32,97.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "220.49px 97.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M213.16,97c-.09.72-.55,1.25-1,1.2s-.76-.67-.66-1.38.55-1.25,1-1.2S213.26,96.25,213.16,97Z",
    fill: "#263238",
    style: {
      transformOrigin: "212.33px 96.91px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M215.46,97.84a24.82,24.82,0,0,1-4.3,5c1.06,1.11,3.25.81,3.25.81Z",
    fill: "#ed893e",
    style: {
      transformOrigin: "213.31px 100.763px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208,97.18c-.15,1.14,1,2.09,2.59,2.29s3.06-.67,3.2-1.81",
    fill: "#16A085",
    opacity: 0.4,
    style: {
      transformOrigin: "210.888px 98.3394px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M217.45,98.24c-.22,1.13.89,2.15,2.45,2.45s3.09-.5,3.3-1.62",
    fill: "#16A085",
    opacity: 0.4,
    style: {
      transformOrigin: "220.311px 99.4967px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M220.52,101a4.89,4.89,0,0,1-.54,0,3.8,3.8,0,0,1-2.07-.93,2.08,2.08,0,0,1-.72-1.77,5,5,0,0,0-1.6-.4,3.49,3.49,0,0,0-1.69,0c-.14,1.22-1.66,2.06-3.36,1.85a3.72,3.72,0,0,1-2.07-.92,2.1,2.1,0,0,1-.72-1.77l.48.06a1.61,1.61,0,0,0,.57,1.36,3.24,3.24,0,0,0,1.8.79c1.44.19,2.72-.48,2.85-1.48.07-.56,1.23-.52,2.19-.4s2.1.39,2,.94a1.6,1.6,0,0,0,.57,1.36,3.44,3.44,0,0,0,3.75.48,1.6,1.6,0,0,0,.9-1.17l0-.24,12.34,1.59-.06.48-11.88-1.53a2.15,2.15,0,0,1-1.1,1.29A3.53,3.53,0,0,1,220.52,101Z",
    fill: "#263238",
    style: {
      transformOrigin: "221.471px 99.0337px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M224.46,94.5a.36.36,0,0,0,.2-.06.43.43,0,0,0,.16-.58,4,4,0,0,0-3.14-2.1.43.43,0,0,0-.45.4.42.42,0,0,0,.39.44h0a3.21,3.21,0,0,1,2.47,1.7A.41.41,0,0,0,224.46,94.5Z",
    fill: "#263238",
    style: {
      transformOrigin: "223.052px 93.1299px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210.52,93.37a.43.43,0,0,0,.37-.15,3.41,3.41,0,0,1,2.76-1.34.42.42,0,0,0,.46-.38.41.41,0,0,0-.36-.46,4.3,4.3,0,0,0-3.5,1.65.42.42,0,0,0,.05.59A.51.51,0,0,0,210.52,93.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "212.133px 92.2053px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m264.05 292.16c-7.65-39.32-9.37-70.07-16.63-85l-35.71 4s21.27 58.59 31.66 83.6c10.79 26 32.09 70.42 32.09 70.42h17.84s-16.65-55.11-29.25-73.02z",
    fill: "#263238",
    style: {
      transformOrigin: "252.505px 286.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m150.86 143.31-3.86-2.44a3.22 3.22 0 0 0-4.06 0.47l-2.62 2.76a3 3 0 0 0 0.26 4.37l1.87 1.6a15.25 15.25 0 0 0 5.57 3l5.65 1.67 3.71-4c1.13-4.17-6.52-7.43-6.52-7.43z",
    fill: "#ffb573",
    style: {
      transformOrigin: "148.496px 147.548px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208,141.44c-1.4,3.42-2.77,6.6-4.26,9.85s-3,6.46-4.67,9.65-3.45,6.36-5.47,9.54c-1,1.58-2.11,3.16-3.37,4.75a30.34,30.34,0,0,1-4.6,4.77,16.51,16.51,0,0,1-3.69,2.28c-.42.16-.81.32-1.27.46l-.7.19a8.35,8.35,0,0,1-1.07.19,10,10,0,0,1-3.64-.26,14.82,14.82,0,0,1-4.18-1.91,24,24,0,0,1-2.75-2,65.72,65.72,0,0,1-7.95-8.27c-2.33-2.8-4.53-5.61-6.64-8.48s-4.14-5.69-6.22-8.7l11.06-7.14a149.17,149.17,0,0,0,11.56,16.15,54.44,54.44,0,0,0,6.37,6.59,12.56,12.56,0,0,0,1.41,1c.37.25.74.35.48.26a2.56,2.56,0,0,0-1.08-.06,2.38,2.38,0,0,0-.43.08h-.08c-.05,0-.05,0-.06,0a6.05,6.05,0,0,0,.65-.49,18.45,18.45,0,0,0,2.47-2.74c.85-1.14,1.7-2.42,2.51-3.75a91.72,91.72,0,0,0,4.52-8.54c1.4-3,2.75-6,4-9.12s2.44-6.29,3.45-9.32Z",
    fill: "#16A085",
    style: {
      transformOrigin: "177.76px 159.801px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.6,
    style: {
      transformOrigin: "177.76px 159.801px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M208,141.44c-1.4,3.42-2.77,6.6-4.26,9.85s-3,6.46-4.67,9.65-3.45,6.36-5.47,9.54c-1,1.58-2.11,3.16-3.37,4.75a30.34,30.34,0,0,1-4.6,4.77,16.51,16.51,0,0,1-3.69,2.28c-.42.16-.81.32-1.27.46l-.7.19a8.35,8.35,0,0,1-1.07.19,10,10,0,0,1-3.64-.26,14.82,14.82,0,0,1-4.18-1.91,24,24,0,0,1-2.75-2,65.72,65.72,0,0,1-7.95-8.27c-2.33-2.8-4.53-5.61-6.64-8.48s-4.14-5.69-6.22-8.7l11.06-7.14a149.17,149.17,0,0,0,11.56,16.15,54.44,54.44,0,0,0,6.37,6.59,12.56,12.56,0,0,0,1.41,1c.37.25.74.35.48.26a2.56,2.56,0,0,0-1.08-.06,2.38,2.38,0,0,0-.43.08h-.08c-.05,0-.05,0-.06,0a6.05,6.05,0,0,0,.65-.49,18.45,18.45,0,0,0,2.47-2.74c.85-1.14,1.7-2.42,2.51-3.75a91.72,91.72,0,0,0,4.52-8.54c1.4-3,2.75-6,4-9.12s2.44-6.29,3.45-9.32Z",
    fill: "#fff",
    style: {
      transformOrigin: "177.76px 159.801px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M234.18,126.09c-3.75,7-17.1,33.67-18.72,50.13-5.91-15-4.62-48.18-4.62-48.18a44.43,44.43,0,0,0-12.27,3A7.41,7.41,0,0,0,194,137.3a262.07,262.07,0,0,0,1.62,51.47c4.15,32.3,8,82.53,8,82.53s33.05-1.38,58.55-6.76c-3.11-24.69-13.75-66.07-13.85-77.15-.12-14.26.21-42.14.66-53.78a6.89,6.89,0,0,0-5.52-7.07A34.57,34.57,0,0,0,234.18,126.09Z",
    fill: "#16A085",
    style: {
      transformOrigin: "227.791px 198.631px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M234.18,126.09c-3.75,7-17.1,33.67-18.72,50.13-5.91-15-4.62-48.18-4.62-48.18a44.43,44.43,0,0,0-12.27,3A7.41,7.41,0,0,0,194,137.3a262.07,262.07,0,0,0,1.62,51.47c4.15,32.3,8,82.53,8,82.53s33.05-1.38,58.55-6.76c-3.11-24.69-13.75-66.07-13.85-77.15-.12-14.26.21-42.15.66-53.79a6.78,6.78,0,0,0-5.21-7A34.31,34.31,0,0,0,234.18,126.09Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      transformOrigin: "227.791px 198.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m226.39 265.94c-5.74-31.67-10.29-78.14-10.66-83.73h0.51c0.37 5.59 4.93 52 10.66 83.67z",
    fill: "#fff",
    style: {
      transformOrigin: "221.315px 224.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m223.53 209.6h-30.48a2.85 2.85 0 0 1-2.64-2.17l-10.19-47.37a1.7 1.7 0 0 1 1.7-2.17h30.47a2.85 2.85 0 0 1 2.65 2.17l10.19 47.37a1.7 1.7 0 0 1-1.7 2.17z",
    fill: "#fff",
    style: {
      transformOrigin: "202.725px 183.745px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m222.58 210h-31a2.91 2.91 0 0 1-2.69-2.21l-10.37-48.17a1.74 1.74 0 0 1 1.74-2.21h31a2.91 2.91 0 0 1 2.69 2.21l10.36 48.17a1.73 1.73 0 0 1-1.73 2.21z",
    fill: "#16A085",
    style: {
      transformOrigin: "201.417px 183.705px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M226.13,182.82l-7.71-.29a6.61,6.61,0,0,0-2.71.48l-4,1.6a3,3,0,0,0-1.64,4l1.6,3.46a3.24,3.24,0,0,0,3.7,1.74l4.41-1.1s8.28-.66,8.58-5Z",
    fill: "#ffb573",
    style: {
      transformOrigin: "219.087px 188.216px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.42,130.38c1.91,3,3.66,5.74,5.38,8.68s3.41,5.85,5,8.89,3.1,6.18,4.47,9.54a48.59,48.59,0,0,1,1.82,5.39,22.59,22.59,0,0,1,.88,6.87v.39a1.92,1.92,0,0,1,0,.2c0,.36-.1.72-.17,1.08s-.16.64-.26,1-.21.55-.32.83a11.17,11.17,0,0,1-1.46,2.42,17.45,17.45,0,0,1-2.77,2.76,36.41,36.41,0,0,1-5,3.31,95.27,95.27,0,0,1-9.52,4.54c-3.15,1.34-6.29,2.56-9.45,3.71s-6.27,2.26-9.56,3.36l-3.81-12.6c3-.82,6.06-1.83,9.05-2.85s6-2.16,8.84-3.35a77.92,77.92,0,0,0,8.14-3.93,23.49,23.49,0,0,0,3.17-2.11,3.81,3.81,0,0,0,.7-.69,1.07,1.07,0,0,0-.2.33c0,.09-.05.15-.1.26a2.37,2.37,0,0,0-.09.36,2.43,2.43,0,0,0-.08.47c0,.06,0,.07,0,.05v-.07a11.76,11.76,0,0,0-.55-2.79,36.08,36.08,0,0,0-1.42-3.85,78.1,78.1,0,0,0-4.14-8.07c-1.56-2.68-3.22-5.36-5-8s-3.6-5.27-5.43-7.67Z",
    fill: "#16A085",
    style: {
      transformOrigin: "243.814px 161.865px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.7,
    style: {
      transformOrigin: "243.814px 161.865px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.42,130.38c1.91,3,3.66,5.74,5.38,8.68s3.41,5.85,5,8.89,3.1,6.18,4.47,9.54a48.59,48.59,0,0,1,1.82,5.39,22.59,22.59,0,0,1,.88,6.87v.39a1.92,1.92,0,0,1,0,.2c0,.36-.1.72-.17,1.08s-.16.64-.26,1-.21.55-.32.83a11.17,11.17,0,0,1-1.46,2.42,17.45,17.45,0,0,1-2.77,2.76,36.41,36.41,0,0,1-5,3.31,95.27,95.27,0,0,1-9.52,4.54c-3.15,1.34-6.29,2.56-9.45,3.71s-6.27,2.26-9.56,3.36l-3.81-12.6c3-.82,6.06-1.83,9.05-2.85s6-2.16,8.84-3.35a77.92,77.92,0,0,0,8.14-3.93,23.49,23.49,0,0,0,3.17-2.11,3.81,3.81,0,0,0,.7-.69,1.07,1.07,0,0,0-.2.33c0,.09-.05.15-.1.26a2.37,2.37,0,0,0-.09.36,2.43,2.43,0,0,0-.08.47c0,.06,0,.07,0,.05v-.07a11.76,11.76,0,0,0-.55-2.79,36.08,36.08,0,0,0-1.42-3.85,78.1,78.1,0,0,0-4.14-8.07c-1.56-2.68-3.22-5.36-5-8s-3.6-5.27-5.43-7.67Z",
    fill: "#fff",
    style: {
      transformOrigin: "243.814px 161.865px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M237.3,165.08a.39.39,0,0,1-.33-.19.39.39,0,0,1,.12-.55l1.56-1a8.5,8.5,0,0,0,3.8-8.86l-3.14-15.9a5.38,5.38,0,0,0-10.46-.44l-4.45,15.59a8.47,8.47,0,0,0,3,9.14l1.48,1.12a.4.4,0,0,1,.07.56.39.39,0,0,1-.55.07L227,163.51a9.28,9.28,0,0,1-3.33-10l4.46-15.59a6.18,6.18,0,0,1,12,.5l3.14,15.91a9.28,9.28,0,0,1-4.15,9.68l-1.57,1A.33.33,0,0,1,237.3,165.08Z",
    fill: "#263238",
    style: {
      transformOrigin: "233.377px 149.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M239.7,138.91h0l-11.23-.47a.4.4,0,0,1-.38-.42.42.42,0,0,1,.42-.38l11.22.47a.4.4,0,0,1,.38.42A.39.39,0,0,1,239.7,138.91Z",
    fill: "#263238",
    style: {
      transformOrigin: "234.1px 138.275px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M234.24,134.25a.41.41,0,0,1-.4-.39c0-2-.62-5.47-2.49-6.23a.4.4,0,1,1,.3-.74c2.77,1.14,3,6.36,3,7a.41.41,0,0,1-.39.41Z",
    fill: "#263238",
    style: {
      transformOrigin: "232.864px 130.575px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M199.89,147.84h-.08a.4.4,0,0,1-.31-.47c1.32-6.57,6.78-16.94,11.59-20a.39.39,0,0,1,.54.13.38.38,0,0,1-.12.54c-4.65,2.94-9.95,13-11.23,19.47A.4.4,0,0,1,199.89,147.84Z",
    fill: "#263238",
    style: {
      transformOrigin: "205.594px 137.576px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m203.17 148.87c-0.62 1.59-2 2.55-3 2.14s-1.39-2-0.77-3.63 2-2.55 3-2.13 1.4 2.03 0.77 3.62z",
    fill: "#fff",
    style: {
      transformOrigin: "201.287px 148.127px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M229.57,164.36c0,.74-.46,1.33-.95,1.31s-.87-.64-.84-1.39.46-1.34.95-1.31S229.6,163.61,229.57,164.36Z",
    fill: "#fff",
    style: {
      transformOrigin: "228.675px 164.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M238.19,164.72c0,.74-.45,1.33-.95,1.31s-.86-.64-.83-1.39.45-1.33,1-1.31S238.22,164,238.19,164.72Z",
    fill: "#fff",
    style: {
      transformOrigin: "237.3px 164.68px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "338.955px 183.005px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m407.77 150.85-1-0.06a15.41 15.41 0 0 0-15.49-16.61v-1a16.4 16.4 0 0 1 16.49 17.67z",
    fill: "#16A085",
    style: {
      transformOrigin: "399.55px 142.015px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 402.54,
    y: 159.04,
    width: 8.28,
    height: 1,
    fill: "#16A085",
    style: {
      transformOrigin: "406.68px 159.54px",
      transform: "rotate(-85.9958deg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m391.28 136.68h-69a15.18 15.18 0 0 0-14.88 13.94l-0.63 9.29a12.91 12.91 0 0 0 13 13.94h69l13.38 8.25 2.12-31.48a12.9 12.9 0 0 0-12.99-13.94z",
    fill: "#16A085",
    style: {
      transformOrigin: "355.52px 159.39px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 323.87,
    y: 149.99,
    width: 63.91,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "355.825px 151.15px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 339.77,
    y: 158.22,
    width: 47.45,
    height: 2.32,
    fill: "#fff",
    style: {
      transformOrigin: "363.495px 159.38px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M287.48,186.38H358a13.19,13.19,0,0,1,13.29,14.25l-.64,9.5a15.53,15.53,0,0,1-15.21,14.25H284.91l-14.82,8.45,2.18-32.2A15.52,15.52,0,0,1,287.48,186.38Z",
    fill: "#fff",
    style: {
      transformOrigin: "320.711px 209.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M287.48,186.38H358a13.19,13.19,0,0,1,13.29,14.25l-.64,9.5a15.53,15.53,0,0,1-15.21,14.25H284.91l-14.82,8.45,2.18-32.2A15.52,15.52,0,0,1,287.48,186.38Z",
    fill: "#16A085",
    opacity: 0.15,
    style: {
      transformOrigin: "320.711px 209.605px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 289.06,
    y: 199.99,
    width: 65.36,
    height: 2.38,
    fill: "#16A085",
    opacity: 0.5,
    style: {
      transformOrigin: "321.74px 201.18px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 288.49,
    y: 208.4,
    width: 25.83,
    height: 2.38,
    fill: "#16A085",
    opacity: 0.5,
    style: {
      transformOrigin: "301.405px 209.59px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 320.65,
    y: 208.4,
    width: 16.5,
    height: 2.38,
    fill: "#16A085",
    opacity: 0.5,
    style: {
      transformOrigin: "328.9px 209.59px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroupierDoctor);
export default __webpack_public_path__ + "static/media/croupier-doctor.d8eddea32ce6df260e42038f856fedd6.svg";
export { ForwardRef as ReactComponent };